import { Subscription } from 'rxjs';

export function AutoUnsubscribe() {
  return function (constructor: any) {
    const original = constructor.prototype.ngOnDestroy;

    constructor.prototype.ngOnDestroy = function () {
      for (const prop in this) {
        const property = this[prop];

        // ✔ Single subscription
        if (property instanceof Subscription) {
          if (!property.closed) {
            property.unsubscribe();
          }
        }

        // ✔ Array of subscriptions
        if (Array.isArray(property)) {
          property.forEach((item) => {
            if (item instanceof Subscription && !item.closed) {
              item.unsubscribe();
            }
          });
        }
      }

      original && original.apply(this);
    };
  };
}
